import React, { FunctionComponent, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { useParams } from 'react-router-dom';
import i18next from 'i18next';

import useTypedSelector from 'hooks/useTypedSelector';
import { onGetForm, onGetOne, onSave } from 'redux/actions/matzeva.actions';
import {
  matzevaFormSelector,
  matzevaCementeriesSelector,
  matzevaFilesSelector,
} from 'redux/selectors/matzeva.selector';

import LayoutContainer from 'containers/LayoutContainer';
import MatzevaForm from 'views/public/MatzevaView/components/MatzevaForm';
import Loading from 'components/commons/Loading';

import { IMatzevaFormData } from 'views/public/MatzevaView/components/MatzevaForm/types';

import 'views/public/MatzevaView/components/MatzevaForm/i18n';

const MatzevaFormContainer: FunctionComponent = () => {
  const dispatch = useDispatch();
  const { id = '' } = useParams<{ id?: string }>();
  const initialValues = useTypedSelector(matzevaFormSelector);
  const { loading } = useTypedSelector((state) => state.matzeva);
  const cementeries = useTypedSelector(matzevaCementeriesSelector);
  const files = useTypedSelector(matzevaFilesSelector);
  const isEditing = !!id;

  useEffect(() => {
    dispatch(onGetForm());
    if (id) dispatch(onGetOne(id));
    return () => {
      dispatch(onGetOne(''));
    };
  }, [dispatch, id]);

  const onSubmit = (formData: IMatzevaFormData) => dispatch(onSave(formData, id));

  return (
    <LayoutContainer isPublic title={i18next.t<string>('PUBLIC_PROCEDURES_VIEW:TITLE')}>
      <MatzevaForm
        cementeries={cementeries}
        files={files}
        initialValues={initialValues}
        isEditing={isEditing}
        onSubmit={onSubmit}
      />
      {loading && <Loading isModalMode message={i18next.t('MATZEVA_FORM:LOADING')} />}
    </LayoutContainer>
  );
};

export default MatzevaFormContainer;
